<h1 mat-dialog-title class="text-black">Session timeout</h1>
<div mat-dialog-content>
    <p class="text-gray-500">No activity found, are you still with us?</p>
    <p class="text-gray-500">You will be logged out in <b>{{counter}}</b> Seconds</p>
</div>
<div mat-dialog-actions class="justify-end">
  <button mat-button (click)="onStay()" >STAY</button>
  <button mat-button (click)="onLogOut()" >LOG OUT</button>
</div>